import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'removeFromObject'
})
export class RemoveFromObjectPipe implements PipeTransform {

	transform(object: any, propertyArray: string[]): any {
		const copyObject = JSON.parse(JSON.stringify(object));
		propertyArray.forEach((property: string) => delete copyObject[property]);

		return copyObject;
	}

}